import React, { useState, useEffect, Dispatch, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import Moment from "moment";
import { guid } from "@solimat/solimat-web-endpoint/lib/user/dto";
import PageMenu from "../../blocks/PageMenu/PageMenu";
import Modal from "components/blocks/Modal/Modal";
import Icon from "components/blocks/Icon/Icon";
import TableEpisode from "../../blocks/TableAppointment/TableEpisode";
import FormValidateOTP from "components/blocks/Forms/FormValidateOTP";
import NoData from "components/pages/noData/NoData";
import useGetEpisode from "../../../services/recordSheets/useGetEpisode";
import useCheckTypes from "../../../hooks/useCheckRecordStatusAndTypes";
import useModal from "hooks/useModal";
import IMGnotice from "../../../img/icons/symbols/notice.png";
import "./EpisodeDetail.scss";
import useDecode from "hooks/useDecode";
import useGetEpisodeImage from "services/recordSheets/useGetEpisodeImage";
import MapGoogle2 from "components/blocks/MapGoogle/MapGoogle2";
import HealthcareDocumentsGrid from "components/blocks/Grids/HealthcareDocumentsGrid";
import useGetRequestDocumentOtp from "services/record/useGetRequestDocumentOtp";
import useGetDocumentstByEpisodeId from "services/record/useGetDocumentstByEpisodeId ";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import GridEpisodeImages from "components/blocks/Grids/GridEpisodeImages";
import useGetImage from "services/recordSheets/useGetImage";

const smoothScrollTo = (
  targetPosition: number,
  duration: number,
  onComplete?: () => void
) => {
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime: number | null = null;

  const animation = (currentTime: number) => {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const nextTime = Math.min(timeElapsed, duration);
    const run = ease(nextTime, startPosition, distance, duration);

    window.scrollTo({
      top: run,
      behavior: 'instant' as ScrollBehavior
    });

    if (timeElapsed < duration) {
      requestAnimationFrame(animation);
    } else {
      if (onComplete) onComplete();
    }
  };

  const ease = (t: number, b: number, c: number, d: number) => {
    return c * t / d + b;
  };

  requestAnimationFrame(animation);
};

const EpisodeDetail: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, episodeType, episodeId } = useParams<{ id: string; episodeType: string; episodeId: string }>();
  const locationState = location.state as any;
  const prevNavigation = locationState?.origin;
  const paramsId = id || '';
  const arrParamsId = paramsId.split("_");
  const recordId = arrParamsId[1];
  const contingencyType = arrParamsId[2];
  const [episode, setEpisode] = useState<any | null>(null);
  const [documentID, setDocumentID] = useState<string | guid>("");
  const [highlightId, setHighlightId] = useState<string | null>(null);
  const documentsRef = useRef<HTMLDivElement>(null);
  const tokenResponse = useDecode("token");
  const userId = tokenResponse && tokenResponse.extension_id;
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);
  const [imagen, setimagen] = useState("");
  const sesionId = episodeId;
  const episodeIdReha = locationState?.episodeId;
  const [loadingImage, setLoadingImage] = useState(false);
  const [errorImage, setErrorImage] = useState('')
  const [openModalError, setOpenModalError] = useState(true)
  const {
    collapsed,
    childrenProps,
    handleOpenModal,
    handleCloseModal,
    disabledCloseButton,
    handleDisableCloseButton,
  } = useModal();
  const { dataImage, getImagesbyId } = useGetImage();

  const { checkEpisodeType, checkContingencyType } =
    useCheckTypes();
  const {
    getVisit,
    getRehabilitation,
    getHospitalization,
    getOperationRoom,
    loadingGetEpisode,
    getEmergencies,
    dataEpisode,
    getEpisodeImagesbyId,
  } = useGetEpisode();
  const { documentsByEpisodeId, getDocumentstByEpisodeId, clearDocumentsByEpisodeId } =
    useGetDocumentstByEpisodeId();
  const { getRequestDocumentOtp, errorGetRequestDocumentOtp } =
    useGetRequestDocumentOtp();

  const previousEpisodeId = useRef(episodeId);

  useEffect(() => {
    if (previousEpisodeId.current !== episodeId && previousEpisodeId.current !== undefined) {
      // Limpiar estados y refrescar datos cuando cambia el episodio
      setEpisode(null);
      clearDocumentsByEpisodeId();
    }
    previousEpisodeId.current = episodeId;
    handleGetEpisode(episodeType, setEpisode);
  }, [episodeId, episodeType]);

  useEffect(() => {
    if (dataEpisode !== null) {
      setEpisode(dataEpisode);
    }
  }, [dataEpisode]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const scrollTo = queryParams.get("scrollTo");

    if (scrollTo === "documents" && documentsRef.current && documentsByEpisodeId) {
      setTimeout(() => {
        if (documentsRef.current) {
          const headerOffset = 180;
          const elementPosition = documentsRef.current.getBoundingClientRect().top;
          const currentPosition = window.pageYOffset;
          const offsetPosition = elementPosition + currentPosition - headerOffset;

          const distance = Math.abs(offsetPosition - currentPosition);
          const speedPxPerMs = 1.0;
          const calculatedDuration = Math.max(500, distance / speedPxPerMs);

          const hId = queryParams.get("highlightId");

          smoothScrollTo(offsetPosition, calculatedDuration, () => {
            if (hId) {
              setHighlightId(hId);
            }
          });
        }
      }, 100);
    }
  }, [location, documentsByEpisodeId]);

  const handleGetEpisode = (episodeType: string, _cb: Dispatch<any>) => {
    switch (episodeType) {
      case "202": //Hospitalizacion
        return getHospitalization(userId, recordId, episodeId, _cb);
      case "204": // Quirófano
        return getOperationRoom(userId, recordId, episodeId, _cb);
      case "205": //Rehabilitación
        return getRehabilitation(userId, recordId, episodeIdReha, sesionId);
      case "200": //consulta
        return getVisit(userId, recordId, episodeId, _cb);
      case "206": //urgencias
        return getEmergencies(userId, recordId, episodeId, _cb);
      case "203": //IMAGEN
        return getEpisodeImagesbyId(userId, recordId, episodeId, _cb);
    }
  };
  const [breadcrumbsParams, setBreadcrumbsParams] = useState<null | any[]>(
    null
  );
  useEffect(() => {
    // AFTER SET EPISODE
    if (episode !== null && episode.episodioId) {
      getDocumentstByEpisodeId(userId, recordId, episode.episodioId);
      let episodeType2 = checkEpisodeType(parseInt(episodeType));
      let contingencyTypeBreadCrumbs = checkContingencyType(
        parseInt(contingencyType)
      );
      setBreadcrumbs([
        "Historial",
        contingencyTypeBreadCrumbs,
        episodeType2,
        "Detalle",
      ]);
      setBreadcrumbsParams([
        {},
        {},
        {
          record: {},
          filter: {
            type_id: episodeType,
            type: "Consultas",
          },
        },
      ]);
    }
  }, [episode, dataImage, episodeId]);

  const handleGoBack = () => {
    navigate(`/historial/${id}/informacion-asistencial`, {
      state: {
        record: {},
        filter: {
          type_id: episodeType,
          type: "Consultas",
        },
      }
    });
  };
  const handleRequestDocument = (documentID: string) => {
    setDocumentID(documentID);
    handleOpenModal();
    getRequestDocumentOtp(userId, recordId, documentID);
  };
  const handleRequestImage = async (id: string, name: string, e: any) => {
    e.preventDefault();
    setDocumentID(id);
    setLoadingImage(true);

    try {
      const miImagen2 = await getImagesbyId(id);
      if (miImagen2) {
        const blob = new Blob([miImagen2], { type: "image/jpeg" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        // a.target = '_blank';
        a.download = `${name}.jpg`;
        a.click();
        window.URL.revokeObjectURL(url); //To do Cambio a useBlob
        setLoadingImage(false);
      } else {
        console.error("La variable dataImage está vacía.");
      }
    } catch (error) {
      setLoadingImage(false);
      setErrorImage("Error al obtener la imagen:")
      setOpenModalError(false)
      // console.error("Error al obtener la imagen:", error);
    }
  };

  // REDIRECT TO GOOGLE MAPS
  const redirect = (latitud: number, longitud: number) => {
    window.open(`https://maps.google.com/?q=${latitud},${longitud}`);
  };

  const formatAddress = (address: any) => {
    const {
      tipoCalle,
      nombreCalle,
      numeroCalle,
      piso,
      puerta,
      letra,
      bloque,
      codigoPostal,
      provincia,
      localidad,
    } = address && address;
    let formatedAddress: string = "";
    let formatedStreet: string = "";
    if (nombreCalle) {
      if (tipoCalle) formatedStreet += tipoCalle;
      formatedStreet += ` ${nombreCalle}`;
    }
    if (formatedStreet) {
      formatedAddress += formatedStreet;
      numeroCalle
        ? (formatedAddress += `, número ${numeroCalle} `)
        : (formatedAddress += ", - ");
      if (piso) formatedAddress += `, piso ${piso}`;
      if (puerta) formatedAddress += `, puerta ${puerta}`;
      if (letra) formatedAddress += `, letra ${letra}`;
      if (bloque) formatedAddress += `, bloque ${bloque}`;
    }

    if (formatedStreet && codigoPostal) {
      formatedAddress += `, C.P. ${codigoPostal}`;
    } else if (!formatedStreet && codigoPostal) {
      formatedAddress += `C.P. ${codigoPostal}`;
    }

    if ((formatedStreet || codigoPostal) && localidad) {
      formatedAddress += ` - ${localidad}`;
    } else if (!formatedStreet && !codigoPostal && !provincia && localidad) {
      formatedAddress += `${localidad}`;
    }

    if ((formatedStreet || codigoPostal || localidad) && provincia) {
      formatedAddress += `, ${provincia}`;
    } else if ((!formatedStreet || !codigoPostal) && provincia) {
      formatedAddress += `${provincia}`;
    }

    return formatedAddress;
  };

  if (loadingGetEpisode) {
    return (
      <section className="container">
        <LoaderMin />
      </section>
    );
  }

  return (
    <>
      {episode !== null ? (
        <>
          <PageMenu
            title={episode !== null ? episode.Titulo : ""}
            breadcrumbs={breadcrumbs}
            params={breadcrumbsParams}
          >
            <div className="btns-header-container">
              <button
                className="btn btn--ghost btn--sm"
                onClick={
                  typeof prevNavigation === "string"
                    ? handleGoBack
                    : () => navigate(-1)
                }
              >
                <Icon name="arrow-left" size={16} /> Volver
              </button>
            </div>
          </PageMenu>

          <section className="section apptd-section">
            <div className="container">

              <h3 className="section-h"><span className="section-h__bar" />Información del episodio</h3>

              <div className="apptd-card">
                {episode !== null && (
                  <TableEpisode
                    episode={episode}
                    episodeType={parseInt(episodeType)}
                  />
                )}
              </div>

              <div className="col-md-12 map-appointment-container">
                <MapGoogle2
                  latitudeCenter={parseFloat(episode?.centro?.latitud?.replace(",", "."))}
                  longitudeCenter={parseFloat(episode?.centro?.longitud?.replace(",", "."))}
                  redirect={redirect}
                  zoom={18}
                  title={episode?.centro?.descripcion}
                />
              </div>

              <h3 className="section-h"><span className="section-h__bar" />Detalles del centro</h3>

              <div className="apptd-misc">
                <dl>
                  {episode?.centro && (
                    <div>
                      <dt>Dirección</dt>
                      <dd>{formatAddress(episode.centro)}</dd>
                    </div>
                  )}
                  {episode?.centro?.telefono && (
                    <div>
                      <dt>Teléfono de contacto</dt>
                      <dd><a href={`tel:${episode?.centro?.telefono}`}>{episode?.centro?.telefono}</a></dd>
                    </div>
                  )}
                </dl>
              </div>

                <div className="col-12 col-md-12 col-lg-12">
                  <h2 className="section-title mt-4 ">Datos asistenciales</h2>
                  <div className="col-lg-12 p-0">
                    {episode !== null ? (
                      <div>
                        <ul className="episode-info__list">
                          {parseInt(episodeType) !== 200 &&
                            parseInt(episodeType) !== 205 &&
                            parseInt(episodeType) !== 203 ? (
                            <>
                              <li>
                                <span className="header">
                                  Diagnóstico CIE9:
                                </span>
                                <span className="data">
                                  {episode?.diagCIE9Principal
                                    ? episode?.diagCIE9Principal
                                    : ""}
                                </span>
                              </li>
                              <li>
                                <span className="header">
                                  Diagnóstico CIE10:
                                </span>
                                <span className="data">
                                  {episode?.diagCIE10Principal
                                    ? episode?.diagCIE10Principal
                                    : ""}
                                </span>
                              </li>
                            </>
                          ) : (
                            ""
                          )}
                          {/* IMAGEN */}

                          {parseInt(episodeType) === 203 && (
                            <>
                              <li>
                                <span className="header">
                                  Asistencial:
                                </span>
                                <span className="data">
                                  {episode?.nombreFacultativo}
                                </span>
                              </li>
                            </>
                          )}
                          {/* CONSULTA */}
                          {parseInt(episodeType) === 200 && (
                            <>
                              <li>
                                <span className="header">
                                  Asistencial:
                                </span>
                                <span className="data">
                                  {episode?.nombreFacultativo}
                                </span>
                              </li>
                              <li>
                                <span className="header">Area lesionada:</span>
                                <span className="data">{episode?.motivo}</span>
                              </li>
                              <li>
                                <span className="header">Mecanismo de lesión:</span>
                                <span className="data">
                                  {episode?.problema}
                                </span>
                              </li>
                            </>
                          )}
                          {/* REHABILITACIÓN */}
                          {parseInt(episodeType) === 205 && (
                            <>
                              <li>
                                <span className="header">
                                  Rehabilitación Finalizada{" "}
                                </span>
                                <span className="data">
                                  {episode.finalizadaRehabilitacion
                                    ? "Si"
                                    : "No"}
                                </span>
                              </li>
                              <li>
                                <span className="header">Número de serie:</span>
                                <span className="data">
                                  {episode.numeroSerie}
                                </span>
                              </li>
                              <li>
                                <span className="header">Asistencial:</span>
                                <span className="data">
                                  {episode.nombreAsistencial}
                                </span>
                              </li>

                            </>
                          )}
                          {/* QUIRÓFANO */}
                          {parseInt(episodeType) === 204 && (
                            <>
                              <li>
                                <span className="header">Cirujano:</span>
                                <span className="data">{episode.cirujano}</span>
                              </li>
                              <li>
                                <span className="header">Anestesista:</span>
                                <span className="data">
                                  {episode.anestesista}
                                </span>
                              </li>
                            </>
                          )}
                          {/* HOSPITALIZACIÓN */}
                          {parseInt(episodeType) === 202 && (
                            <>
                              <li>
                                <span className="header">
                                  Fecha alta hospitalaria:
                                </span>
                                <span className="data">
                                  {episode?.FechaHoraFin != null
                                    ? Moment(
                                      new Date(
                                        episode?.FechaHoraFin?.toString()
                                      )
                                    ).format("DD/MM/YYYY")
                                    : ""}
                                </span>
                              </li>
                              <li>
                                <span className="header">
                                  Días de estancia:
                                </span>
                                <span className="data">
                                  {episode.diasEstancia}
                                </span>
                              </li>
                              <li>
                                <span className="header">
                                  Descripcion Servicio:
                                </span>
                                <span className="data">
                                  {episode.servicioDescripcion}
                                </span>
                              </li>

                              <li>
                                <span className="header">Asistencial:</span>
                                <span className="data">
                                  {episode.medicoResponsable}
                                </span>
                              </li>
                            </>
                          )}
                          {/* URGENCIAS */}
                          {parseInt(episodeType) === 206 && (
                            <>
                              <li>
                                <span className="header">Especialidad:</span>
                                <span className="data">
                                  {episode.especialidad}
                                </span>
                              </li>
                              <li>
                                <span className="header">
                                  Asistencial:
                                </span>
                                <span className="data">
                                  {episode.nombreFacultativo}
                                </span>
                              </li>
                              <li>
                                <span className="header">
                                  Descripcion Servicio:
                                </span>
                                <span className="data">
                                  {episode.servicioDescripcion}
                                </span>
                              </li>
                            </>
                          )}
                          {episode.document && (
                            <li className="d-flex">
                              <span className="header">Hoja de visita:</span>
                              <a
                                className="d-flex btn-text-icon"
                                onClick={() =>
                                  handleRequestDocument(episode.document.id)
                                }
                              >
                                <span className="data btn-text mr-1">
                                  {episode.document.description}
                                </span>
                                <span className="download-icon"></span>
                              </a>
                            </li>
                          )}
                        </ul>
                        <Modal
                          disabledCloseButton={disabledCloseButton}
                          collapsed={collapsed}
                          onClose={handleCloseModal}
                          title={"Introduzca el código"}
                          subtitle={
                            "Para visualizar el documento, introduzca el código que hemos enviado a su teléfono"
                          }
                        >
                          {collapsed ? (
                            <div className="ghost-form"></div>
                          ) : (
                            <>
                              {documentsByEpisodeId ? (
                                <FormValidateOTP
                                  handleDisableCloseButton={
                                    handleDisableCloseButton
                                  }
                                  onClose={handleCloseModal}
                                  userId={userId}
                                  prestacionId={recordId}
                                  documentID={documentID}
                                />
                              ) : (
                                <>
                                  {errorGetRequestDocumentOtp ? (
                                    <div>
                                      <h3 className="modal_title">Error</h3>
                                      <p className="c-center">
                                        Lo sentimos, se ha producido un error
                                      </p>
                                    </div>
                                  ) : (
                                    <p className="loader-text c-center">
                                      Loading...
                                    </p>
                                  )}
                                </>
                              )}
                            </>
                          )}
                        </Modal>
                      </div>
                    ) : (
                      <p>- No hay observaciones para esta cita</p>
                    )}
                  </div>
                </div>
              <div ref={documentsRef} className="col-sm-12 col-md-12 col-lg-12 record-container-documents" style={{ marginTop: '20px', padding: '0px 15px' }}>
                <h2 className="section-title">Documentos</h2>
                
                {!Array.isArray(documentsByEpisodeId) || documentsByEpisodeId.length === 0 ? (
                  <NoData message="No hay disponible documentación" />
                ) : (
                  <div>
                    <HealthcareDocumentsGrid
                      key={`documents-${episodeId}`}
                      handleRequestDocument={handleRequestDocument}
                      highlightId={highlightId}
                      documents={documentsByEpisodeId.map((doc: any) => {
                        return {
                          nombre: doc.nombre,
                          extension: doc.extension,
                          company: doc.company ?? "-",
                          fecha: doc.fecha,
                          id: doc.id,
                          uri: doc.uri,
                          requiereOtp: doc.requiereOtp,
                        };
                      })}
                    />
                  </div>
                )}
              </div>
              {parseInt(episodeType) === 203 && (
                <>
                  <h3 className="section-h"><span className="section-h__bar" />Imágenes</h3>
                  <GridEpisodeImages
                    handleRequestImage={handleRequestImage}
                    images={episode.referenciasImagenes}
                    loadingImage={loadingImage}
                  />
                </>
              )}

            </div>
          </section>
        </>
      ) : (
        <></>
      )}

      {errorImage && (
        <Modal collapsed={openModalError} title="Error al descargar imagen">
          <div className="error-download-img">
            <img src={IMGnotice} style={{ marginBottom: "40px" }} alt="" />
          </div>
          <div className="container btns-container container-btn-close-error-img" style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              type="button"
              className="btn-box btn-accent"
              onClick={() => setOpenModalError(true)}
            >
              Cerrar
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default EpisodeDetail;
